module.exports = __webpack_public_path__ + "bot1.8255c867.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/bot1.png
// module id = 1584
// module chunks = 0